import ApplicationSerializer from 'cio/serializers/application';
import { ModelSchema } from 'ember-data';
import { ModelRegistry } from 'ember-data/model';

export default class ActionSerializer extends ApplicationSerializer {
  attrs = {
    // Copy is an attribute only used internally to track actions while copying
    // in the VWB
    _copy: {
      serialize: false,
    },
    // preBranchWaitUntil is a flag to indicate whether this action has been
    // migrated to support branching - it's only generated in the UI and should
    // not be sent to the backend
    isPreBranchWaitUntil: {
      serialize: false,
    },
  };

  normalize(type: ModelSchema<keyof ModelRegistry>, hash: Record<string, any>, prop?: string) {
    if (hash.type === 'conditional_wait_action') {
      hash.is_pre_branch_wait_until = hash.multi_conditions == null;
    }

    return super.normalize(type, hash, prop);
  }
}
